import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcVpn = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M8.002 5.061a.493.493 0 0 1 .322-.466l3.325-1.247a1 1 0 0 1 .702 0l3.324 1.247a.493.493 0 0 1 .323.466c-.009.832-.05 2.965-.248 4.155-.192 1.15-2.292 2.593-3.263 3.205a.908.908 0 0 1-.974 0c-.971-.612-3.072-2.055-3.263-3.205-.199-1.19-.24-3.323-.248-4.155Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M6.552 6.966H3.5v1.5h3.148a32.758 32.758 0 0 1-.096-1.5Zm4.698 6.976v3.274h1.5v-3.274c-.487.16-1.013.16-1.5 0Zm6.102-5.476H20.5v-1.5h-3.052a32.673 32.673 0 0 1-.096 1.5Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M3 7.716a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm21 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-10.5 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
  fill: "var(--mds-nav-icon-medium)"
})), "IcVpn");

export { IcVpn };
//# sourceMappingURL=ic-vpn.js.map
